export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";